import type { CityConfig } from "../city-template/types";

export const devilsLakeConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Devils Lake",
  state: "North Dakota",
  stateAbbr: "ND",
  slug: "devils-lake",
  route: "/devils-lake",
  title: "Emergency Passport Devils Lake, ND — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Devils Lake, ND — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Devils Lake, Spirit Lake Nation, Lake Region State College, and Ramsey County. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in Devils Lake, ND",
  heroSubtitle: "Devils Lake fishing tournament heading to Canada? Lake Region State College student planning a study abroad trip? Military family at Camp Grafton with PCS orders? We help Devils Lake residents — from world-class anglers to Spirit Lake Nation members to LRSC Royals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20landscape%20view%20of%20Devils%20Lake%20North%20Dakota%20with%20the%20namesake%20lake%20stretching%20across%20the%20horizon%2C%20fishing%20boats%20on%20the%20water%20at%20sunrise%2C%20the%20downtown%20Devils%20Lake%20area%20with%20historic%20buildings%2C%20the%20Lake%20Region%20State%20College%20campus%2C%20dramatic%20prairie%20sky%20with%20golden%20morning%20light%20reflecting%20on%20calm%20lake%20waters%2C%20editorial%20travel%20photography%20with%20crisp%20natural%20colors&width=1800&height=700&seq=devils-lake-hero-2026&orientation=landscape",
  heroImageAlt: "Devils Lake North Dakota lake view at sunrise",
  geoPosition: "48.1128;-98.8651",
  geoPlacename: "Devils Lake, North Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Nearest regional passport agency — located approximately 385 miles from Devils Lake; about a 5.5-hour drive",
  },
  nearbyCitiesZips: [
    { name: "Devils Lake", zips: "58301" },
    { name: "Fort Totten", zips: "58335" },
    { name: "Lakota", zips: "58344" },
    { name: "Cando", zips: "58324" },
    { name: "Rugby", zips: "58368" },
    { name: "Carrington", zips: "58421" },
    { name: "New Rockford", zips: "58356" },
  ],
  benefits: [
    { icon: "ri-anchor-line", title: "World-Class Fishing Hub", desc: "Devils Lake is one of the premier freshwater fishing destinations in North America. Anglers travel from across the globe to fish here — and local guides, tournament competitors, and lodge owners frequently travel internationally for fishing expos, tournaments, and guided expeditions in Canada and beyond." },
    { icon: "ri-building-2-line", title: "Camp Grafton Military Families", desc: "Camp Grafton serves as the primary training facility for the North Dakota National Guard. Military families with PCS orders, deployment documentation, and international travel needs require reliable passport services that understand military timelines and requirements." },
    { icon: "ri-graduation-cap-line", title: "Lake Region State College Students", desc: "LRSC brings students from around the region and the world. International students need passports for travel home, while domestic students pursuing study abroad or spring break trips need fast, reliable passport processing that works with the academic calendar." },
    { icon: "ri-group-line", title: "Spirit Lake Nation Community", desc: "Devils Lake is adjacent to the Spirit Lake Reservation. Tribal members traveling for cultural exchanges, educational programs, and family visits internationally need passport services that understand and respect tribal documentation and sovereignty considerations." },
  ],
  internalLinks: [
    { name: "Expedited passport in Grand Forks, ND", route: "/grand-forks" },
    { name: "Fast passport services in Minot, ND", route: "/minot" },
    { name: "Quick passport services in Fargo, ND", route: "/fargo" },
    { name: "Urgent passport services in Bismarck, ND", route: "/bismarck" },
    { name: "North Dakota passport services overview", route: "/north-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Devils Lake via secure registered courier with direct access to the Minneapolis Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 5.5+ hours to Minneapolis. Devils Lake residents can ship from any UPS Store, FedEx Office, or post office in the Lake Region.",
  fpcOfficeDistance: "Serving Devils Lake, Fort Totten, Lakota, Cando, Rugby, Carrington, New Rockford, and all Ramsey County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Devils Lake and the Lake Region. From the fishing lodges and marinas to the LRSC campus and Camp Grafton, from Spirit Lake Nation members to Ramsey County families — we serve all of Devils Lake. Our courier service eliminates the need to drive 385 miles to Minneapolis for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Devils Lake and the entire Lake Region including Fort Totten, Lakota, and Cando. Our service covers Ramsey County and surrounding communities with the same fast processing Devils Lake residents depend on.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Devils Lake as simple as possible — with the reliability Lake Region residents deserve. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Devils Lake travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Devils Lake's unique identity as a fishing mecca, military community, and tribal neighbor creates special passport situations. Here are the most common mistakes we see in the Lake Region.",
  testimonialsIntro: "Devils Lake travelers — from tournament anglers to military families to LRSC students — trust us when international travel deadlines arrive and Minneapolis is simply too far.",
  faqIntro: "Have questions about expedited passports in Devils Lake, ND? Here are the most common ones we hear from our neighbors in the Lake Region.",
  statePageRoute: "/states/north-dakota",
  statePageName: "North Dakota",
  servicesIntro: "Whether you're a tournament angler heading to a Canadian fishing championship, a military family with overseas orders, or an LRSC student preparing for a study abroad adventure — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30-100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.nd.gov/divisions/driverslicense/driverslicense.htm",
  dmvLabel: "North Dakota Department of Transportation — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for anglers, military families, and LRSC students", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Devils Lake", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Minneapolis agency is 385 miles from Devils Lake", "5.5+ hour drive — takes a full day each way"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Fishing tournament in Manitoba next week and your passport is expired? Military deployment orders with immediate travel requirements? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Devils Lake travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Devils Lake residents renew fast — no agency visit required for most renewals. Perfect for Lake Region anglers, LRSC faculty, and Ramsey County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Ramsey County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your fishing trip or military deployment isn't derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Devils Lake family vacation stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations and military IDs.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for tournament anglers traveling while primary passport is in visa processing, and military contractors with overlapping international commitments.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Devils Lake water is beautiful — but not for your passport. Water damage from fishing boats and lake activities is common. We help replace damaged passports quickly so your next trip isn't affected.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, and the Caribbean. Ideal for Devils Lake anglers heading to Manitoba, Saskatchewan, and Ontario for fishing tournaments and guided trips.",
      bullets: ["Wallet-size convenience", "Land crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Devils Lake ND", description: "Urgent passport processing for Devils Lake North Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Devils Lake ND", description: "Fast passport renewal for Devils Lake North Dakota residents." },
    { name: "First-Time Passport Devils Lake ND", description: "New passport application services for Devils Lake North Dakota first-time applicants." },
    { name: "Child Passport Devils Lake ND", description: "Minor passport services for Devils Lake North Dakota families with children under 16." },
    { name: "Name Change Passport Devils Lake ND", description: "Passport name correction for Devils Lake residents after marriage or legal name changes." },
    { name: "Second Passport Devils Lake ND", description: "Second passport services for Devils Lake frequent travelers including tournament anglers." },
  ],
  testimonials: [
    {
      name: "Mike H.",
      location: "Devils Lake",
      rating: 5,
      text: "I'm a walleye tournament angler — the championship in Winnipeg was 10 days away and I realized my passport was expired. Panic mode. Fast Passport Center expedited it in 5 days. Drove to Manitoba, fished the tournament, took 3rd place. Those walleye paid for the expedite fee 50 times over.",
      service: "Expedited Passport Renewal — Fishing Tournament Travel",
    },
    {
      name: "Sarah and Tom D.",
      location: "Devils Lake",
      rating: 5,
      text: "My husband is National Guard at Camp Grafton. Got PCS orders to Germany with reporting date in 3 weeks. Our kids needed first-time passports. Fast Passport Center walked us through the whole process. All four passports arrived on time. We're settled in Kaiserslautern now.",
      service: "Family Passports — Military PCS Orders",
    },
    {
      name: "Chris W.",
      location: "Devils Lake",
      rating: 5,
      text: "LRSC nursing student — got accepted to a medical mission trip to Guatemala. They told me about the opportunity 2 weeks before departure. Passport was expired. Fast Passport Center expedited in 4 days. Spent a week providing health care in rural villages. Changed my entire perspective on nursing.",
      service: "Expedited Passport — Medical Mission Trip",
    },
    {
      name: "The Elk Family",
      location: "Fort Totten",
      rating: 5,
      text: "Our daughter was invited to a Native youth cultural exchange program in New Zealand. First-time passport, tight deadline, and we needed to make sure all Spirit Lake documentation was correct. Fast Passport Center was patient, thorough, and got it done in 7 days. She's having the experience of a lifetime.",
      service: "First-Time Child Passport — Cultural Exchange",
    },
  ],
  facilities: [
    {
      id: "devilslake-1",
      name: "Devils Lake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "502 4th St NE",
      city: "Devils Lake",
      state: "ND",
      zip: "58301",
      phone: "(701) 662-3201",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Downtown Devils Lake",
      website: "https://tools.usps.com/find-location.htm?location=1372603",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Devils Lake and Ramsey County. Passport photos available on-site. Appointment recommended — limited slots during peak fishing season.",
      icon: "ri-mail-line",
    },
    {
      id: "devilslake-2",
      name: "Ramsey County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "524 4th Ave NE, Unit 10",
      city: "Devils Lake",
      state: "ND",
      zip: "58301",
      phone: "(701) 662-1309",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      distance: "Downtown Devils Lake — Ramsey County Courthouse",
      website: "https://www.ramseycountynd.gov/",
      websiteLabel: "Ramsey County Website",
      notes: "Alternative to post office acceptance. Appointment recommended. Does not offer photo services — bring your own passport photo or get one at the Devils Lake Post Office first.",
      icon: "ri-government-line",
    },
    {
      id: "devilslake-3",
      name: "Grand Forks Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2501 28th Ave S",
      city: "Grand Forks",
      state: "ND",
      zip: "58201",
      phone: "(701) 335-2240",
      hours: "Mon-Fri 8:30 AM - 5:00 PM (appointment required)",
      distance: "Grand Forks — about 90 miles east of Devils Lake",
      website: "https://tools.usps.com/find-location.htm?location=1377668",
      websiteLabel: "USPS Location",
      notes: "Larger acceptance facility with more appointment availability. Full passport photo service. About 1.5 hour drive from Devils Lake via US-2.",
      icon: "ri-mail-line",
    },
    {
      id: "devilslake-4",
      name: "Rugby Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 2nd St SW",
      city: "Rugby",
      state: "ND",
      zip: "58368",
      phone: "(701) 776-6141",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Rugby — about 60 miles west of Devils Lake",
      website: "https://tools.usps.com/find-location.htm?location=1379713",
      websiteLabel: "USPS Location",
      notes: "Serves western Ramsey County and Pierce County residents. Home of the Geographical Center of North America monument. Small facility; call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "devilslake-5",
      name: "Carrington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "87 9th Ave N",
      city: "Carrington",
      state: "ND",
      zip: "58421",
      phone: "(701) 652-2241",
      hours: "Mon-Fri 9:00 AM - 3:00 PM (appointment required)",
      distance: "Carrington — about 50 miles south of Devils Lake",
      website: "https://tools.usps.com/find-location.htm?location=1373923",
      websiteLabel: "USPS Location",
      notes: "Alternative for southern Ramsey County residents. Call for passport acceptance hours and photo availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Minneapolis Passport Agency, 385 miles and 5.5+ hour drive from Devils Lake", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Minneapolis; requires a full day each way plus overnight from Devils Lake", fpc: "Most Devils Lake travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — impractical from Devils Lake", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Devils Lake", agency: "385-mile drive — full day each way; requires overnight stay in Minneapolis", fpc: "Entirely remote — forms online, ship from Devils Lake, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel, hotel, and time off work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples and resellers" },
    { feature: "Devils Lake Context", agency: "No local guidance — no fishing tournament, military, or Lake Region expertise", fpc: "Full Devils Lake knowledge — anglers, Camp Grafton, LRSC, Spirit Lake Nation" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Fishing Tournament Passport Rush",
      description: "Devils Lake is a world-class fishery and tournament destination. Anglers competing in Canadian walleye, pike, and perch tournaments often discover expired passports days before the event. Tournament entry fees are non-refundable, making last-minute passport processing critical. We recommend anglers check passport validity when registering for tournaments.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Military PCS Documentation Timing",
      description: "Camp Grafton military families with Permanent Change of Station (PCS) orders overseas face fixed reporting dates. The military provides relocation support but passport processing is the service member's responsibility. Starting the passport process early — before receiving final orders — prevents last-minute crises.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Devils Lake Water Damage",
      description: "Devils Lake is central to life here, and passports carried in tackle boxes, boat consoles, or wet waders are prone to water damage. A water-damaged passport is considered mutilated by the State Department and must be replaced. Lake Region anglers should store passports in waterproof cases.",
    },
    {
      icon: "ri-error-warning-line",
      title: "LRSC Academic Calendar Deadlines",
      description: "Lake Region State College students accepted to study abroad programs or international internships face rigid semester deadlines. The window between acceptance and departure is often just 3-6 weeks — and visa processing consumes most of that. Passport renewal should happen before program applications, not after acceptance.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Spirit Lake Documentation Coordination",
      description: "Tribal members of the Spirit Lake Nation may have unique documentation situations involving tribal IDs, Bureau of Indian Affairs records, and state-issued documents. Understanding which documents are acceptable for passport applications in each situation requires careful attention. We have experience navigating these requirements.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a fishing tournament, military deployment, or study abroad semester." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you're an angler, military family, student, or Ramsey County resident." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Devils Lake clients ship from the Devils Lake Post Office or UPS — no Minneapolis trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Devils Lake travelers never need to drive 385 miles to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Devils Lake address — whether that's near the lake, downtown, or on the Spirit Lake Reservation. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Devils Lake, North Dakota?", a: "We offer Devils Lake area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is in Minneapolis (385 miles away), our remote courier service is the most practical fast option for the Lake Region." },
    { q: "Do I need to visit a Devils Lake office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Devils Lake Post Office or Ramsey County Clerk), then ship documents overnight. We handle State Department submission and return your passport to your Lake Region address." },
    { q: "Can tournament anglers get passports for Canadian fishing competitions?", a: "Yes. Devils Lake is a major tournament fishing hub and many competitions are in Manitoba, Saskatchewan, and Ontario. We process expedited passports for tournament anglers — and we understand that tournament registration deadlines and entry fees make time absolutely critical." },
    { q: "What about military families at Camp Grafton needing passports for PCS orders?", a: "Absolutely. We work with National Guard and Reserve families facing PCS orders to overseas assignments. We understand military timelines and the No-Fee passport process for official travel. For personal/tourist passports needed alongside official orders, we expedite to meet reporting dates." },
    { q: "What is the best price for expedited passport service in Devils Lake?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Devils Lake applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos." },
    { q: "Can I get a passport photo in Devils Lake?", a: "Yes. The Devils Lake Post Office offers on-site passport photos. Walmart in Devils Lake may provide photo services — call ahead to confirm. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "Can you help with Spirit Lake Nation members' passport applications?", a: "Yes. We have experience working with tribal members on passport applications and understand the documentation considerations involved. We guide applicants through the process with respect and attention to the specific ID and vital record situations that may apply." },
    { q: "How far is the nearest airport for Devils Lake international travel?", a: "Devils Lake Regional Airport (DVL) offers limited commercial service. Most Devils Lake international travelers use Grand Forks International Airport (GFK, 90 miles east) or fly from Fargo (FAR, 165 miles southeast) connecting through Minneapolis or Denver." },
    { q: "What happens if my passport gets water damaged during a fishing trip on Devils Lake?", a: "Water-damaged passports are considered mutilated and must be replaced before international travel. If your passport gets soaked in Devils Lake, contact us immediately. We expedite mutilated passport replacements and can have a new passport to you typically in 5-10 business days." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Devils Lake Residents",
    intro: "Devils Lake's identity as a fishing destination, military community, and educational center shapes how residents travel. Here's what you need to know.",
    cards: [
      {
        icon: "ri-anchor-line",
        title: "Tournament Fishing Travel",
        subtitle: "Devils Lake anglers competing across North America",
        description: "Devils Lake is one of the premier walleye, perch, and pike fisheries in the United States. Local guides, lodge owners, and tournament anglers travel to Canadian competitions in Manitoba, Saskatchewan, and Ontario year-round. Fishing expos in Europe and Asia also draw Devils Lake professionals showcasing techniques and tackle.",
        tip: "Tournament anglers should check passport validity when registering for any Canadian event. Tournament entry fees are often non-refundable. A passport card may suffice for driving to Manitoba — but passport books are required for any fly-in tournaments or international expos.",
      },
      {
        icon: "ri-shield-line",
        title: "Camp Grafton Military Travel",
        subtitle: "National Guard families with unique passport needs",
        description: "Camp Grafton is the North Dakota National Guard's primary training site. Service members and their families may receive PCS orders to Germany, Korea, Italy, or other overseas assignments. Military families may also need No-Fee (official) passports in addition to tourist passports for personal travel while stationed abroad.",
        tip: "Military PCS orders come with fixed reporting dates that cannot be extended. Start the passport process before receiving final orders if possible. Tourist passports for family members should be applied for in parallel with No-Fee official passports for the service member.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Lake Region State College International Programs",
        subtitle: "LRSC students going global",
        description: "LRSC offers study abroad and international exchange opportunities. Nursing students participate in medical missions, agriculture students visit international operations, and general studies students study abroad for a semester. The community college timeline — with shorter programs and tighter budgets — makes every day count for passport processing.",
        tip: "LRSC students should check passport validity before applying for study abroad programs, not after acceptance. Many countries require 6 months of passport validity beyond the program end date. An expired passport discovered after acceptance can jeopardize the entire opportunity.",
      },
      {
        icon: "ri-compass-3-line",
        title: "Canadian Lake Region Adventures",
        subtitle: "Cross-border recreation from the Lake Region",
        description: "Devils Lake's fishing culture naturally extends to Canadian waters just hours away. Lake Winnipeg, Lake Manitoba, and the vast network of lakes in northern Saskatchewan and Manitoba are popular destinations. Hunting trips for waterfowl and big game in Canada are also common from the Lake Region.",
        tip: "Canadian fishing and hunting regulations require specific documentation at the border — proof of firearm registration for hunting trips, fishing licenses, and in some cases a sponsor letter from a Canadian outfitter. Passport processing is the first step, but border documentation preparation is equally important.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Devils Lake & the Northern Plains",
      description: "Devils Lake sits in a unique geographic position in north-central North Dakota. The lake itself — the largest natural body of water in the state — has been expanding for decades due to a wet climate cycle, reshaping the region's geography and economy. It's a hub connecting the Red River Valley to the east, the Drift Prairie to the south, and the Canadian border region to the north.",
    },
  },
  destinations: {
    title: "Where Devils Lake Travelers Go — And Why Passports Get Urgent",
    intro: "Devils Lake's fishing culture, military presence, and educational community shape its international travel patterns.",
    stats: [
      { stat: "35%", label: "of Devils Lake expedited requests involve fishing tournament and outdoor travel" },
      { stat: "3-5 Weeks", label: "average lead time for military PCS passport processing" },
      { stat: "May-Sep", label: "peak season for fishing tournaments and summer travel" },
      { stat: "385 Miles", label: "distance to nearest passport agency — our courier keeps you in ND" },
    ],
    destinations: [
      { name: "Canada", context: "Manitoba walleye championships, Saskatchewan fly-in fishing lodges, Ontario tournament circuits, Winnipeg shopping and events", urgency: "Tournament schedules — often with 1-2 weeks' notice", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Military PCS to Germany and Italy, fishing expos in the Netherlands and Germany, LRSC study abroad programs, Lake Region family heritage trips", urgency: "PCS orders with fixed reporting dates; academic deadlines for students", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Military deployments and PCS to Korea and Japan, fishing tackle manufacturing trips to China, LRSC international student travel home", urgency: "Military timelines and academic breaks", icon: "ri-map-pin-2-line" },
      { name: "Central & South America", context: "LRSC medical mission trips to Guatemala and Honduras, ecotourism and fishing adventures in Costa Rica and Belize, missionary work", urgency: "Mission trip schedules — typically 2-6 weeks' notice", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter escapes from North Dakota winters, destination weddings, spring break trips for LRSC students, cruise departures", urgency: "Fall and winter planning for warm getaways", icon: "ri-map-pin-2-line" },
      { name: "Australia & Oceania", context: "Spirit Lake cultural exchanges, fishing industry expos, LRSC student exchange programs, once-in-a-lifetime adventures", urgency: "Cultural exchange program timelines — 3-8 weeks", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Peace Garden State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Grand Forks", route: "/grand-forks" },
      { name: "Minot", route: "/minot" },
      { name: "Fargo", route: "/fargo" },
    ],
  },
  photoLocations: [
    { name: "Devils Lake Post Office", address: "502 4th St NE, Devils Lake, ND 58301", hours: "Mon-Fri 9 AM - 3:30 PM (photo service available)", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walmart Supercenter — Devils Lake", address: "1424 Hwy 2 E, Devils Lake, ND 58301", hours: "Daily 6 AM - 11 PM (call to confirm photo hours)", website: "https://www.walmart.com/" },
    { name: "Grand Forks Main Post Office", address: "2501 28th Ave S, Grand Forks, ND 58201", hours: "Mon-Fri 8:30 AM - 5 PM (full photo service, 90 min drive)", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walgreens — Grand Forks", address: "1950 32nd Ave S, Grand Forks, ND 58201", hours: "Daily 8 AM - 10 PM (90 min drive)", website: "https://www.walgreens.com/" },
    { name: "The UPS Store — Grand Forks", address: "3650 S Columbia Rd, Grand Forks, ND 58201", hours: "Call for hours (90 min drive)", website: "https://www.theupsstore.com/" },
  ],
  dmvLocations: [
    {
      name: "ND DOT — Devils Lake Driver License Office",
      address: "219 6th St NW, Devils Lake, ND 58301",
      hours: "Mon-Fri, 8:00 AM - 4:45 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, vehicle registration. Primary office serving the Lake Region. Located in downtown Devils Lake.",
      featured: true,
    },
    {
      name: "Ramsey County Treasurer — Motor Vehicle",
      address: "524 4th Ave NE, Unit 10, Devils Lake, ND 58301",
      hours: "Mon-Fri, 8:00 AM - 4:30 PM",
      note: "Vehicle registration and title services for Ramsey County. For driver licenses, visit the ND DOT office.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DVL",
      name: "Devils Lake Regional Airport",
      distance: "About 5 minutes from downtown Devils Lake",
      address: "1720 Hwy 20 S, Devils Lake, ND 58301",
      note: "Limited commercial service. Primary Devils Lake airport for general aviation and some regional flights. Most scheduled international connections require Grand Forks or Fargo.",
      flightUrl: "https://www.devilslakend.com/",
      flightLabel: "Devils Lake Airport",
      featured: true,
    },
    {
      code: "GFK",
      name: "Grand Forks International Airport",
      distance: "About 90 miles east of Devils Lake",
      address: "2301 Airport Dr, Grand Forks, ND 58203",
      note: "Nearest airport with regular commercial service. Allegiant flights to Las Vegas, Phoenix, and seasonal destinations. Most Devils Lake international travelers connect through GFK, FAR, or drive to MSP. About 1.5 hours from Devils Lake via US-2.",
      flightUrl: "https://www.gfkairport.com/",
      flightLabel: "Grand Forks Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Dakota birth certificates from the ND Department of Health Vital Records. Online, mail, or in-person options available in Bismarck.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through ND Department of Health Vital Records. Required for estate and legal matters in Ramsey County.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Ramsey County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://www.ramseycountynd.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Ramsey County District Court. Required for name change passport corrections.",
      url: "https://www.ramseycountynd.gov/",
    },
  ],
};